var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-tooltip',{attrs:{"custom-class":'ui-tooltip' + ' ' + (_vm.customClass || ''),"placement":"top","target":_vm.target,"triggers":_vm.trigger || 'hover'}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }